export default __webpack_public_path__ + "static/media/Logo-slides-web.1a843296.jpg";